export const ageMethod = "age nearest";
export const gateway = "https://qat-insurebc-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/insurebc";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJpbnN1cmViYyIsIm5hbWUiOiJpbnN1cmViYyIsImlhdCI6MTc4MDU4MjgzMiwiZXhwIjoxOTM4MzcwODMyfQ._EM4B8CdI-cH_rpOtnrFUF0T5ky5VCEufN6OOLyvc9Y";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-insurebc-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_insurebc",
			brands: [
				"qat-insurebc-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "insurebc",
			email: "lifeinsurance@insurebc.ca",
			environment: "qat",
			environment_id: "qat",
			ftcLink: "https://www.insurebc.ca/company/terms-and-conditions",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map1": [
					"104-1847 W Broadway",
					"Vancouver",
					"BC",
					"V6J 1Y6",
				],
			},
			menuPhone: "button",
			phone: "1-604-813-2737",
			privacyLink: "https://www.insurebc.ca/company/privacy-policy",
			website: "https://www.insurebc.ca/",
			scope: "insurebc#branding#qat-insurebc-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-insurebc-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_insurebc",
			brands: [
				"qat-insurebc-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "insurebc",
			email: "lifeinsurance@insurebc.ca",
			environment: "qat",
			environment_id: "qat",
			ftcLink: "https://www.insurebc.ca/company/terms-and-conditions",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map1": [
					"104-1847 W Broadway",
					"Vancouver",
					"BC",
					"V6J 1Y6",
				],
			},
			menuPhone: "button",
			phone: "1-604-813-2737",
			privacyLink: "https://www.insurebc.ca/company/privacy-policy",
			website: "https://www.insurebc.ca/",
			scope: "insurebc#branding#qat-insurebc-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-insurebc-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 14:20:32 GMT+0000 (Coordinated Universal Time)
